module.exports = __webpack_public_path__ + "img/action-cam-1.239f0133.png";